import Loader from "react-loader-spinner";
import { COLORS } from "../constants/Colors";

function SmallLoadingSpinner() {
  return (
    <div className="d-flex mr-5 pr-1">
      <div className="">
        <Loader type="Puff" color={COLORS.iStaffGreen} height={40} width={40} />
      </div>
    </div>
  );
}

export default SmallLoadingSpinner;
